/* eslint-disable no-console */

import { register } from "register-service-worker";
import notus from "notus";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const promptUserToRefresh = (reg: any) => {
  notus().send({
    message: "Er is een nieuwe versie van The Real You App beschikbaar!",
    closable: false,
    autoClose: false,
    notusType: "snackbar",
    notusPosition: "top",
    htmlString: true,
    actionable: true,
    primaryAction: {
      text: "installeren",
      actionHandler: function() {
        if (reg && reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
      }
    }
  });
};

//if (process.env.NODE_ENV === "production") {
register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {
    console.log("App is being served from cache by a service worker.\n" + "For more details, visit https://goo.gl/AFskqB");
  },
  registered() {
    console.log("Service worker has been registered.");
  },
  cached() {
    console.log("Content has been cached for offline use.");
  },
  updatefound() {
    console.log("New content is downloading.");
  },
  updated(registration) {
    promptUserToRefresh(registration);
    console.log("New content is available; please refresh.");
  },
  offline() {
    console.log("No internet connection found. App is running in offline mode.");
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  }
});
if (navigator.serviceWorker) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", function() {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
//}
